import {graphql, useStaticQuery} from 'gatsby';
import {buildImageLookups, createMicrositeImageHooks} from 'microsites/core/chatMicrosite/images/micrositeImageHooks';
import {useMemo} from 'react';
import {images} from './images';
import type {ImageKey} from './images';
import type {ImageLookups, MicrositeImageQueryResult} from 'microsites/core/chatMicrosite/images/micrositeImageHooks';

const useMicrositeImageLookups = (): ImageLookups<ImageKey> => {
  const data = useStaticQuery<MicrositeImageQueryResult>(graphql`
    query ChatCoffeeMicrositeImages {
      allFile(filter: {sourceInstanceName: {eq: "chatCoffeeImages"}, extension: {in: ["png", "jpg", "jpeg", "webp", "svg"]}}) {
        nodes {
          name
          publicURL
          childImageSharp {
            defaultImage: gatsbyImageData(layout: CONSTRAINED, placeholder: BLURRED, formats: [AUTO, WEBP, AVIF], quality: 80, breakpoints: [256, 384, 512, 640, 768, 960, 1280], outputPixelDensities: [1, 1.5, 2])
            instagramCardImage: gatsbyImageData(layout: FIXED, placeholder: BLURRED, formats: [AUTO, WEBP, AVIF], quality: 74, width: 420, outputPixelDensities: [1, 1.5])
            heroDesktopImage: gatsbyImageData(layout: FULL_WIDTH, placeholder: NONE, formats: [AUTO, WEBP, AVIF], quality: 68, breakpoints: [640, 960, 1280, 1536], outputPixelDensities: [1, 1.5])
            heroMobileImage: gatsbyImageData(layout: CONSTRAINED, placeholder: NONE, formats: [AUTO, WEBP, AVIF], quality: 66, width: 960, outputPixelDensities: [1, 1.5])
            tinyAvatarImage: gatsbyImageData(layout: CONSTRAINED, placeholder: BLURRED, formats: [AUTO, WEBP, AVIF], width: 96, height: 96, quality: 86, outputPixelDensities: [1, 2])
          }
        }
      }
    }
  `);

  return useMemo(() => {
    return buildImageLookups<ImageKey>(data.allFile.nodes, images);
  }, [data]);
};

export const {useMicrositeImage, useFauxInstagramImage} = createMicrositeImageHooks<ImageKey>({
  images,
  useLookups: useMicrositeImageLookups,
});
